import { PaginationRequest } from '../common/Pagination';
import { Crud } from '../common/Edit';

export enum AsstTpCd {
  EQUIPMENT = 'EQP',
  SPARE_PARTS = 'SP',
  ETC_ASST = 'ETC',
}
//'REQUEST' | 'REPLY' | 'READ'; //요청, 회신, 결과(읽기전용)
export enum AsstRvwType {
  REQUEST = 'REQUEST', //요청
  REPLY = 'REPLY', //회신
  READ = 'READ', //검토내역
}

export enum RvwStatCd {
  REVIEW = 'RVW',
  COMPLETE = 'CPLT',
}

export interface IdleAssetCondition {
  copCds?: string[]; // 법인코드목록 (멀티콤보용 화면에서만 사용)
  copCd?: string; // 대상법인코드
  eqpNm?: string; // 설비명
  asstNm?: string; // 고정자산명
  rvwStatCd?: string; // 검토상태코드
  rvwRltDivsCd?: string; // 검토결과구분코드
  rvwReqTitNm?: string; // 요청제목
  dataInsUserId?: string; // 요청자
  startDate?: string; // 요청일 검색시작일
  endDate?: string; // 요청일 검색종료일
  rvwReqId?: string; //요청번호
  wrtUserId?: string; //검토자
  asstTpCd?: string; //분류
  comboValue?: string;

  prdnProcCd?: string; //대상공정
  tgtCopCd?: string; //대상법인
  crgeDeptCd?: string; //대상부서
  eqpId?: string; // 설비ID
  infrUserNms?: string; //통보담당자

  plblCop?: string; //활용부서
  plblYn?: string; //활용여부
}

/**
 * 불용자산기본
 */
export interface IdleAssetMaster extends Crud {
  rvwReqId?: string; // 검토요청ID
  rvwReqTitNm?: string; // 검토요청제목명
  rvwReqCtn?: string; // 검토요청내용
  asstRvwReqCopCd?: string; // 법인코드
  rvwCpltDt?: string; // 검토완료일자
  rvwStatCd?: string; // 검토상태코드
  rvwStatCdNm?: string; // 검토상태코드명
  rmk?: string; // 비고
  atchFileGrId?: string; // 첨부파일그룹ID
  atchFileCnt?: string;
  useYn?: string; // 사용여부
  optValCtn1?: string; // 옵션값내용1
  optValCtn2?: string; // 옵션값내용2
  optValCtn3?: string; // 옵션값내용3
  optValCtn4?: string; // 옵션값내용4
  optValCtn5?: string; // 옵션값내용5
  dataInsUserId?: string; // 데이터입력사용자ID
  dataInsUserNm?: string; // 데이터입력사용자명
  dataInsUserIp?: string;
  dataInsDtm?: string; // 데이터입력일시
  dataUpdUserId?: string; // 데이터수정사용자ID
  dataUpdUserNm?: string; // 데이터수정사용자명
  dataUpdUserIp?: string;
  dataUpdDtm?: string; // 데이터수정일시
  eqpCount?: number; // 설비대수
  progressRate?: string; // 검토율
  deptRvwRoleYn?: string;
  rvwRltDivsCd?: string; // 검토결과구분코드
  rvwRltDivsCdNm?: string; // 검토결과구분코드명
  asstTpCd?: string; // 자산유형코드
  asstTpCdNm?: string; // 자산유형코드명
  reqDeptCd?: string; //요청부서코드
  aprReqId?: string; //  결재요청ID
  tgtCopCd?: string; // 활용법인
  rvwDt?: string; //최근 검토일자
}

/**
 *불용자산상세
 */
export interface IdleAssetDetail extends Crud {
  rvwReqId?: string; // 검토요청ID
  asstTpCd?: string; // 자산유형코드
  asstTpCdNm?: string; // 자산유형코드명
  eqpIdExstYn?: string; // 설비ID존재여부
  eqpOwnCopCd?: string; // 설비의 법인코드
  prdnPldoCd?: string; // 생산프랜트동코드
  eqpId?: string; // 설비ID
  eqpNm?: string; // 설비명
  rvwStatCd?: string; // 검토상태코드
  rvwStatCdNm?: string; // 검토상태코드명
  asstRvwTpCd?: string; // 검토유형코드
  rvwRltDivsCd?: string; // 검토결과코드
  rvwRltDivsCdNm?: string; // 검토결과코드명
  rvwRltCtn?: string; // 검토결과내용
  tgtCopCd?: string; // 대상법인코드
  crgeDeptCd?: string; // 담당부서코드
  cctrCd?: string; // 코스트센터코드
  cctrNm?: string; // 코스트센터명
  asstNo?: string; // 자산번호
  asstNm?: string; // 자산명
  prdnProcCd?: string; // 공정코드
  prdnProcCdNm?: string; // 공정코드명
  procNm?: string; // 공정명
  acqrDt?: string; // 취득일자
  mdlNm?: string; // 모델명
  asstAcqrAmt?: string; // 자산취득금액
  deprAmt?: string; // 감가상각금액
  asstQty?: string; // 자산수량
  asstQtyUnitNm?: string; // 자산수량단위명
  rmk?: string; // 비고
  atchFileGrId?: string; // 첨부파일그룹ID
  useYn?: string; // 사용여부
  optValCtn1?: string; // 옵션값내용1
  optValCtn2?: string; // 옵션값내용2
  optValCtn3?: string; // 옵션값내용3
  optValCtn4?: string; // 옵션값내용4
  optValCtn5?: string; // 옵션값내용5
  dataInsUserId?: string; // 데이터입력사용자ID
  dataInsUserNm?: string; // 데이터입력사용자명
  dataInsUserIp?: string;
  dataInsDtm?: string; // 데이터입력일시
  dataUpdUserId?: string; // 데이터수정사용자ID
  dataUpdUserNm?: string; // 데이터수정사용자명
  dataUpdUserIp?: string;
  dataUpdDtm?: string; // 데이터수정일시
  progressRate?: string; // 검토율
  atchFileCnt?: number; // 첨부파일수

  asstRvwReqCopCd?: string; //검토요청법인코드
  reqDeptCd?: string; //요청부서
  rvwReqTitNm?: string; //검토요청제목
  reqInsUserNm?: string; //요청자명
  rvwCpltDt?: string; //검토완료일
  reqInsDeptNm?: string; //검토요청부서명
  deptRvwRoleYn?: string; //부서검토권한여부

  //sp 추가된 컬럼
  asstQtyInv?: string; // 재고수량
  asstQtyInvOn?: string; //
  invTpCd?: string; //재고유형코드
  currCd?: string; //통화코드
  whNm?: string; //창고명
  matGrNm?: string; //자재그룹명
  asstInvNo?: string; //자산재고번호
  asstInvNm?: string; //자산재고명
  mdpNm?: string; //제조사명
  atntItemNm?: string; //대체품목명
}

export interface IdleAssetRequestMaster extends IdleAssetMaster {
  castType?: string; // 서버측 결재요청상세vo > bizReqData cast 타입
  aprReqId?: string;
  requestDetailList?: IdleAssetRequestDetail[];
  currCd?: string; //통화단위
}

export interface IdleAssetRequestDetail extends IdleAssetDetail {
  aprReqId?: string;
}

export interface IdleAssetSummary {
  copCd?: string; // 법인코드
  eqpCount?: number; // 설비대수
  asstAcqrAmt?: number; // 자산취득금액
  deprAmt?: number; // 잔존가액
  puseCount?: number; // 활용
  dpslCount?: number; // 매각
  dcdCount?: number; // 폐기
  currCd?: string;
}

/**
 * EMS S/P 상세팝업
 * ITEMNUM=   뒤에 ITEMNUM 값 넣고 호출하면 됨.
 * 개발서버: https://emsgke-dev.singlex.com/app/ems/popup?mode=spm&itemnum=ZCODERULETEST0031
 * 테스트서버: https://ems2-test-ensol.singlex.com/app/ems/popup?mode=spm&itemnum=BESWI2905
 * 운영서버: https://ems2-ensol.singlex.com/app/ems/popup?mode=spm&itemnum=BMCYL15339
 * @param ITEMNUM
 */
export const openEmsSPLink = (ITEMNUM: string): void => {
  const host = window.location.hostname;
  // console.log('host', host);
  //  console.log('ddd', process.env.NODE_ENV);
  // 'prod';
  let link = 'https://ems2-ensol.singlex.com/app/ems/popup?mode=spm&itemnum=';

  if (host.includes('localhost')) {
    // 'local';
    link = 'https://emsgke-dev.singlex.com/app/ems/popup?mode=spm&itemnum=';
  }
  if (host.includes('elmdev')) {
    // 'dev';
    // return 'https://ems2-test-ensol.singlex.com/app/ems/popup?mode=spm&' ;
    link = 'https://emsgke-dev.singlex.com/app/ems/popup?mode=spm&itemnum=';
  }
  window.open(link + ITEMNUM, '_blank');
};
